import _uniqueId from "lodash/uniqueId"
import { useCallback, useEffect } from "react"

const useDaumPostCode = ({ onComplete }) => {
  const kakaoWrapId = _uniqueId("kakao-map-")

  const execDaumPostCode = useCallback(() => {
    const elementWrap = document.getElementById(kakaoWrapId)
    const daum = window.daum

    if (daum) {
      new daum.Postcode({
        oncomplete: function (data) {
          if (onComplete) {
            onComplete(data)
          }
        },
        width: "100%",
        height: "100%",
      }).embed(elementWrap)
    }
  }, [kakaoWrapId, onComplete])

  useEffect(() => {
    execDaumPostCode()
  }, [execDaumPostCode])

  return { kakaoWrapId }
}

export default useDaumPostCode
